import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router';
import { IonButton, IonIcon } from '@ionic/react';
import { arrowUp, bulb, close, create, gameController, grid, home, library, returnUpBackOutline, schoolOutline } from 'ionicons/icons';
import { useImportStore } from './stateManagement/importZustand';
import { useGlobalStore } from './stateManagement/globalZustand';
import { useUIStore } from './stateManagement/UIZustand';
import { useTreeStore } from './stateManagement/treeZustand';
import { useURLStore } from './stateManagement/URLZustand';
import { Breadcrumbs } from './Breadcrumbs';
import ButtonTemplate from './templates/ButtonTemplate';
import GridMainComponent from './grid/GridMainComponent';
import HelpPage from './HelpPage';
import Suggestion from './Suggestion';
import './Grid.css';
import { _NEW_LINE, _SPACE_CARD, _dict, _libName, _rootName } from './constants';
import { logMe } from '../foo/user';
import React from 'react';
import Card from './Card';
import { isLabelEmpty } from '../foo/grid';
import QModal from './quiz/QModal';
import ImageRetrievalModal from './ImageRetrievalModal';

interface GridProps {
}

function Grid(props: GridProps) {
  const [buttonsTemplate, setButtonsTemplate] = useState<JSX.Element | null>(null);
  const { finishImport } = useImportStore();
  const { isParentMode, lang, homeNodePath, clipboardCards, clipboardPecs } = useGlobalStore();

  //const [longestWord, setLongestWord] = useState(0);
  const {
    positionOfClickedCards,
    selectedLabelsUpdatedToggle,
    isGridMode,
    setIsGridMode,
    setIsArtistMode,
    isQModalOpen,
    setIsQModalOpen,
    IRLabel,
    setIRLabel,
    isIROpen,
    setIsIROpen,
    IRLabelIndex,
    setIRLabelIndex,
    

  } = useUIStore();
  const { snapshot, resetSnapshot, restoreFromSnapshot, nodes, l2Image, setNodes, setL2Image, homeworks,
    path2Params, getImage } = useTreeStore();
  const [showSuggestion2, setShowSuggestion2] = useState<boolean>(false);

  const [showNewLineSuggestion, setShowNewLineSuggestion] = useState<boolean>(false);

  const { URLVars, getURLTo, isLibPath, isHomePage, isHelpPage,
    visibleLabels } = useURLStore();
  const [isReady, setIsReady] = useState<boolean>(false);

  const shuffleLabels = (labels: string[]): string[] => {
    let shuffledLabels = [...labels];
    for (let i = shuffledLabels.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledLabels[i], shuffledLabels[j]] = [shuffledLabels[j], shuffledLabels[i]];
    }
    return shuffledLabels;
  };



  const labels = path2Params[URLVars.nodePath!]?.isRandomFlag ? shuffleLabels(nodes[URLVars.nodePath!]) : nodes[URLVars.nodePath!] || [];
  useEffect(() => {
    finishImport();
  }, []);

  useEffect(() => {
    if (
      isReady === false &&
      homeNodePath !== null &&
      visibleLabels !== null &&
      isParentMode !== null &&
      positionOfClickedCards.length !== null &&
      selectedLabelsUpdatedToggle !== null &&
      isGridMode !== null
    ) {
      setIsReady(true);
    }
  }, [homeNodePath, visibleLabels, isParentMode, positionOfClickedCards.length, selectedLabelsUpdatedToggle, isGridMode]);

  
  

  //const similarCardsCount = useMemo(() => selectedLabelsKeys.length > 0 ? countSimilarStringsWithDuplicates(selectedLabelsKeys[0], visibleLabels) : 0, [selectedLabelsKeys, visibleLabels]);
  const history = useHistory();

  const backButton = useMemo(() => (
    <ButtonTemplate
      key="backButton"
      icon={arrowUp}
      text={_dict.back[lang]}
      onClick={() => {
        let prevPath = getURLTo().talkFromPathBeforeLib();
        if (isLibPath() && prevPath !== undefined) {
          history.push(prevPath);
        } else {
          history.push(getURLTo().talkFromParentNodePath());
        }
      }}
    />
  ), [history, getURLTo, isLibPath, lang]);

  const homeButton = useMemo(() => (
    <ButtonTemplate
      key="homeButton"
      icon={home}
      text={_dict.goToStartingPoint[lang]}
      onClick={() => history.push(getURLTo().home())}
    />
  ), [history, getURLTo, lang]);

  const savedListsButton = (
    <ButtonTemplate
      icon={library}
      text={_dict.library[lang]}
      onClick={() => {
        logMe('click_savedLists', {});
        history.push(getURLTo().lib());
      }}
    />
  );

  useEffect(() => {
    if (isHelpPage()) return;
    let btnLists: any = [];

    if ((URLVars.nodePath === _rootName && !isLibPath()) || (isParentMode === false && isHomePage())) {
      btnLists = [];
    } else {
      btnLists = [backButton];
    }

    if (!isHomePage()) {
      btnLists = [...btnLists, homeButton];
    }

    if (!isLibPath()) {
      btnLists = [...btnLists, savedListsButton];
    }

    const activityButton = (
      <ButtonTemplate
        icon={gameController}
        text={_dict.activities[lang]}
        onClick={() => {
          logMe('click_activity', {});
          history.push(getURLTo().activities());
        }}
      />
    );

    btnLists = [...btnLists, activityButton];

    if (homeworks.length > 0) {
      const homeworkButton = (
        <ButtonTemplate
          icon={schoolOutline}
          text={_dict.homeworks[lang]}
          onClick={() => {
            logMe('click_homework', {});
            history.push(getURLTo().homeworks());
          }}
        />
      );

      btnLists = [...btnLists, homeworkButton];
    }

    const autoQuizButton = (
      <ButtonTemplate
        icon={bulb}
        text={_dict.autoQuiz[lang]}
        onClick={() => {
          logMe('click_autoQuiz', {});
          setIsQModalOpen(true);
        }}
      />
    );

    btnLists = [...btnLists, autoQuizButton];
    
    if(isParentMode === true || (isParentMode === false && visibleLabels.length > 0)){
      const gridModeButton = (
        <ButtonTemplate
          isBlack={isGridMode === true}
          icon={grid}
          text={_dict.gridMode[lang]}
          onClick={() => {
            logMe('click_gridMode', {});
            setIsGridMode(!isGridMode);
          }}
          
        />);


      btnLists = [...btnLists, gridModeButton];
        }

      if (isParentMode === true) {
      if (visibleLabels?.length > 0) {
        const artistModeButton = <ButtonTemplate icon={create} text={_dict.artistMode[lang]} onClick={() => {
          logMe("click_artistMode", {});
          //if(isSubscribed===true){
          // Filter out new lines
          setIsArtistMode(true);

          //}else{
          //  setShowSubscriptionAlertForArtistic(true);
          //}
        }} />;
        btnLists = [...btnLists, artistModeButton];
      }
    }
    if (btnLists.length > 0) {
      setButtonsTemplate(btnLists.map((button: any, index: number) => React.cloneElement(button, { key: index }))
      );
    } else {
      setButtonsTemplate(null);
    }

    //setLongestWord(longestWordInList(visibleLabels || []));

    if (isParentMode === true) {
      setShowSuggestion2(clipboardCards.length > 0 || Object.keys(clipboardPecs).length > 0);
    }
  }, [homeNodePath, visibleLabels, isParentMode,
    positionOfClickedCards.length, selectedLabelsUpdatedToggle,
    isGridMode]);


  if (isReady === false) return null;
  



  /*const handleSelectSimilarCards = () => {
    const similarStrings = findSimilarStrings(selectedLabelsKeys[0], labels);
    const similarStringsUnique = Array.from(new Set(similarStrings));
    
    // Create an object where each key is a unique similar string and its value is an array of positions
    const labelsDictionary = similarStringsUnique.reduce((acc: {[key:string] : number[]}, label) => {
      // For each label, find all indices in the original labels array
      const positions = labels.map((lbl, index) => lbl === label ? index : -1).filter(index => index !== -1);
      // Add to the accumulator object
      acc[label] = positions;
      return acc;
    }, {});
    
    setSelectedLabels(labelsDictionary);

  };

  const deleteCardToDelete = () => {
    let selectedLabelsPositions = Object.values(selectedLabels).flat();
    setNodes(
      deleteNodesWithPrefix(
        deleteLabelsFromNodes(nodes, URLVars.nodePath!, selectedLabelsPositions),
        decodeURIComponent(URLVars.nodePath!),
        selectedLabelsKeys
      )
    );

    resetSelectedLabels();
  };


  const handleEdit = () => {
    if (selectedLabelsKeys.length === 0) return;
    if (selectedLabelsKeys.length === 1 && visibleLabels.includes(selectedLabelsKeys[0])) {
      setIRLabel(selectedLabelsKeys[0]);
      setIsIROpen(true);
    }
  };

  const handleCloseIRModal = (label: string | null, img: string | null) => {
    setIsIROpen(false);
    if (label === null || img === null) return;

    // const realCardToDelete = cardToDelete - cardToDeleteGroupIdx;
    // const newNodes = { ...nodes, [URLVars.nodePath!]: nodes[URLVars.nodePath!].map((item, index) => (index === realCardToDelete ? label : item)) };
    // setNodes(newNodes);
    // if (img.length > 10) {
    //   const newL2Image = { ...l2Image, [label]: img };
    //   setL2Image(newL2Image);
    // }
  };
*/
  function handleOnCloseIRModal(label: string | null, img: string | null): void {
    // Update label and image
    if (label && IRLabelIndex !== null) {
      // Replace the label at the selected index
      const newNodes = [...labels];
      newNodes[IRLabelIndex] = label;
      setNodes({ ...nodes, [URLVars.nodePath!]: newNodes });
      if(img){
        setL2Image({ ...l2Image, [label]: img});
      }
    }
    setIsIROpen(false);
    setIRLabel(null);
    setIRLabelIndex(null);
  }


  return (
    <div className="suggestion-container" style={{ minHeight: '100vh', padding: '0px !important' }}>
      {isGridMode === false && <div className="buttons-container">
        {!isHelpPage() && !showSuggestion2 && !showNewLineSuggestion && buttonsTemplate
        /*selectedLabelsKeys.length > 0 ? (
          <>
            {isSidebarVisible !== true && (
              <ButtonTemplateTwo color="danger" icon={trash} text={_dict.removeSelectedCard[lang]} onClick={deleteCardToDelete} />
            )}
            {selectedLabelsKeys.length < 2 && (
              <ButtonTemplateTwo color="warning" icon={createOutline} text={_dict.editMode[lang]} onClick={handleEdit} />
            )}

            {selectedLabelsKeys.length === 1 && similarCardsCount > 1 && (
              <ButtonTemplateTwo
                icon={null}
                text={_dict.selectSimilarCards[lang] + ' (' + similarCardsCount + ')'}
                onClick={handleSelectSimilarCards}
              />
            )}
            {selectedLabelsKeys.length > 1 &&
              <ButtonTemplateTwo icon={null} text={_dict.selectAllIntermediateCards[lang]} onClick={handleSelectIntermediateCards} />
            }
            <ButtonTemplateTwo icon={null} text={_dict.selectAll[lang]} onClick={handleSelectAll} />
            <ButtonTemplateTwo icon={null} text={_dict.unselectAll[lang]} onClick={handleUnselectAll} />
            
          </>
        ) : (
          !isHelpPage() && !showSuggestion2 && !showNewLineSuggestion && buttonsTemplate
        )*/}
      </div>}


      {/*IRLabel !== null && (
        <ImageRetrievalModal
          onClose={handleCloseIRModal}
          label={IRLabel}
          isOpen={isIROpen}
          initialImage={l2Image[IRLabel] || null}
        />
      )*/}
      {/*props.isMoveMode === true && <Suggestion message={_dict.suggestionMoveMode[lang]} buttons={[]} />*/}
      {showSuggestion2 && (
        <Suggestion
          topPosition={true}
          message={_dict.toPasteBeforeOrInsideACardSelectTheCardFirstAndClickOnPasteButton[lang]}
          buttons={[]}
        />
      )}


      {URLVars.nodePath! !== _rootName && URLVars.nodePath! !== _libName && !isHelpPage() ? (
        <Breadcrumbs path={URLVars.nodePath || ''} pathSeparator="." />
      ) : null}

      {snapshot !== null && (
        <IonButton size="default" color="danger" onClick={() => { restoreFromSnapshot(); }}>
          <IonIcon icon={returnUpBackOutline} slot="start" />
          {_dict.undoDelete[lang]}
        </IonButton>
      )}
      {snapshot !== null && (
        <IonButton size="default" color="dark" onClick={() => { resetSnapshot(); }}>
          <IonIcon icon={close} slot="start" />
          {_dict.doNotUndo[lang]}
        </IonButton>
      )}
      
      
      <div style={{ padding: '10px' }}>{
        // GRID MESSAGES HERE
        isParentMode === true && visibleLabels?.length === 0 && isGridMode === false ? <>{_dict.activateGridModeToInserNewCards[lang]}</> : 
        isParentMode === false && visibleLabels?.length === 0 && isGridMode === false ? <>{_dict.toCreateNewCardsOpenTheLeftLateralMenuAndActivateAdminMode[lang]}</> : null
      }</div>
      
      {isHelpPage() ? (
        <HelpPage />
      ) :
        isGridMode ? <GridMainComponent key={URLVars.nodePath!} totalCells={60}/>
          :


          <div style={{ display: 'flex', flexWrap: 'wrap' }} id="mainContentNoGrid">
            {labels.map((label, index) =>
              [_NEW_LINE].includes(label.trim()) ? (
                // Render a new line for empty labels. An empty div with full width to push content to the next line.
                <div key={index} style={{ width: '100%', height: '0' }}></div>
              ) : isLabelEmpty(label) ? <></>: (
                <Card

                   key={index}
                   index={index}
                   label={label} />
              )
            )}
          </div>}
          <QModal isOpen={isQModalOpen} onClose={() => {setIsQModalOpen(false)}}/>
          {IRLabel !== null && isIROpen === true && <ImageRetrievalModal
          onClose={handleOnCloseIRModal}
          label={IRLabel ?? ''}
          isOpen={isIROpen}
          initialImage={IRLabel ? getImage(IRLabel) || null : null}
        />}
    </div>
  );
}

export default Grid;
